<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok" :loading="loading" @on-cancel="cancel" width="700">
      <h3 slot="header" class="modal-header">选择解约房间</h3>
      <div class="flex">
        <div class="roomlist">
          <h4 class="mb8">房间列表</h4>
          <ul>
            <li v-for="(item,index) in canSelect"
                :class="['ivu-btn',{'btn-primary2':item.isSelected}]"
                :key="'keyA'+index"
                @click.stop="selectItem(item)"
            >{{item.stockNumber}}
            </li>
            <br>
            <li class="item ivu-btn disabled "
                v-for="(item,index) in cannotSelect"
                :key="'keyC'+index"
            >{{item.stockNumber}}
            </li>
          </ul>
        </div>
        <div class="checklist">
          <h4 class="mb8">已选列表</h4>
          <ul>
            <li v-for="(item,index) in checkList" class="ivu-btn btn-primary2"
                :key="'keyB'+index"
                @click.stop="selectItem(item)"
            >{{item.stockNumber}}
            </li>
          </ul>
        </div>
      </div>
      <release-apply  :contractFid="contractFids" :n="n1" @done="applyDone" :mask="true"></release-apply>
    </Modal>
  </div>
</template>
<script>
  import {queryEpsRentRoom} from "../../../../api/contractList";
  import ReleaseApply from './ReleaseApply'
  import {renewstockinfo} from "../../../../api/contractList";

  export default {
    name: "SelectRoom",
    components: {
      ReleaseApply
    },
    props: {
      n: {
        type: Number,
        default: 0
      },
      contractFid: {
        type: String,
        default: null
      },
      parentContractFid: {
        type: String,
        default: null
      }
    },
    watch: {
      n() {
        this.data = []
        // this.queryEpsRentRoom()
        this.renewstockinfo()
        this.isShow = true
      }
    },
    data() {
      return {
        n1: 0,
        loading: true,
        isShow: false,
        data: []
      }
    },
    computed: {
      contractFids() {
        let ret = []
        this.checkList.forEach(ele => {
          ret.push(ele.contractFid)
        })
        return ret

      },
      checkList() {
        return this.canSelect.filter(ele => {
          return ele.isSelected
        })
      },
      checkRoomNums() {
        let ret = []
        this.checkList.forEach(ele => {
          ret.push(ele.stockNumber)
        })
        return ret.join(',')
      },
      checkRoomIds() {
        let ret = []
        this.checkList.forEach(ele => {
          ret.push(ele.contractFid)
        })
        return ret.join(',')
      },
      canSelect() {
        return this.data.filter(ele => {
          // return  ele.surApplyStatus===1 && ele.isRenew===0 && ele.auditState===2
          return ele.isRenew === 0
        })
      },
      cannotSelect() {
        return this.data.filter(ele => {
          // return  ele.surApplyStatus===0 || ele.isRenew===1 || ele.auditState===0 || ele.auditState===1
          return ele.isRenew === 1

        })
      }
    },
    methods: {
      applyDone() {
        this.$emit('done')
        this.isShow = false
      },
      selectItem(item) {
        item.isSelected = !item.isSelected
      },
      renewstockinfo() {
        let params = {
          parentContractFid: this.parentContractFid,
          reNewOrUnRentApply: 1
        }
        renewstockinfo(params).then(res => {
          if (!res.data) {
            this.$Message.info('不存在可选房间')
            return
          }
          res.data.forEach(ele => {
            ele['isSelected'] = false
          })
          this.data = res.data
        }).catch(error => {
        })
      },
      queryEpsRentRoom() {
        if (!this.contractFid) {
          return
        }
        let params = {
          contractFid: this.contractFid
        }
        queryEpsRentRoom(params).then(res => {
          if (!res.data) {
            return
          }
          res.data.forEach(ele => {
            ele['isSelected'] = false
          })
          this.data = res.data
        }).catch(error => {
        })
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {
        if (this.contractFids.length === 0) {
          this.$Message.info('请选择房间')
          this.changeLoading()
          return
        }
        this.n1++
        this.changeLoading()
      },
      cancel() {
      }
    }
  }
</script>

<style scoped>
  .flex {
    display: flex;
    border: 1px solid #DDDEE1;
  }

  .roomlist {
    flex: none;
    width: 55%;
    border-right: 1px solid #DDDEE1;
    padding: 15px;
  }

  .checklist {
    flex: auto;
    padding: 15px;
  }

  li {
    margin: 0 10px 10px 0;
    width: 80px;
  }

</style>
